export type ChainConfiguration = { chainId: string; restUrl: string; rpcUrl: string };
